module.exports = __webpack_public_path__ + "img/featured-tablet-cta-2.310d405d.jpg";